import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          PostSliderItem,
          HomeTitle ,
          ResponsiveYouTubeIframe        } from '../../Components/UI/UI'

import {    newPosts  } from "../../Data/Data";
import { getWeather } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./ValleyDesertPage.css"

class ValleyDesertPage extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {

    getWeather((Weather)=>{
    
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  


  render(){
    // get all posts 
    const  posts = [ ...newPosts ] ;

    // get non video posts and culinary posts
    const valleyDesertPosts = posts.filter((o , i )=>{
       return (o.ctg === 'valleyDesert'  ||  o.ctg === 'valleyDesert') && o.isDouble === false;
    })

    // const thingsToDoPosts = [ ...posts ];


    const postsHtml = valleyDesertPosts.map( (o,i) => {
        // console.log('o' , o);
        let cssClass="";
        let html ="";
        if ( i % 4 === 0 ) {
          cssClass =" first";
        }
        let url = null;
        let component = null;
        
        if (o.isVid === true) {
         
          url  = "/Posts/Videos/" + o.ctg  + '/' + o.id;
          component = <VideoSliderItem  
                        key={i}
                        title={o.title}
                        desc={""}
                        img= {o.img}
                        link={url}
                        cssClass={cssClass} />
        }else {
          // url = "/Posts/" + o.id ;
          url  = "/Posts/" + o.ctg  + '/' + o.id;
          component = <PostSliderItem  
                          key={i}
                          title={o.title}
                          desc={""}
                          img= {o.img}
                          link={url}
                          cssClass={cssClass} />
        }

        return component;
        
    });

    return(
      <div className="inner-page align-center page-valley-desert">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
            JORDAN VALLEY & JUDEAN DESERT 
            </HomeTitle>
            <ResponsiveYouTubeIframe vidId={"FYtk8JMMZRE"} />
            <div className="live-shows-wrapper">
              {postsHtml}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default ValleyDesertPage


// WEBPACK FOOTER //
// ./src/Pages/ValleyDesertPage/ValleyDesertPage.js